import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import styled from "styled-components";
import { DATA_SOURCE_FACADE } from "../deal.constants";
import { getDataSourceFromURL } from "../deal.helper";
import {
  mapServicedDealSelector,
  mapPublicDealSelector,
  mapSreoDealSelector,
} from "../deal.store";

const NavButton = styled.button`
  appearance: none;
  background-color: white;
  padding: 14px 24px;
  border: 1px solid #1468a5;
  color: #1468a5;
  font-family: "Lexend";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s ease;
  user-select: none;

  &:active {
    background: rgba(20, 104, 165, 0.1);
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:not(:first-child):not(:last-child) {
    border-left: 0;
    border-right: 0;
  }

  &.active {
    background: #1468a5;
    color: white;
  }
`;

const NavButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

class DealNavbar extends Component {
  getOnClick = (deal, source) => () => {
    if (!this.props.deal || !this.props.groupedDeals.length) {
      // data is have not been loaded yet
      return;
    }

    const dealId = deal?.dealId || this.props.match.params.dealId;
    this.props.history.push(`/deal-lite/${dealId}?source=${source}`);
  };

  renderButton = (deal, source, text) => {
    return (
      <NavButton
        className={source === getDataSourceFromURL() ? "active" : ""}
        onClick={this.getOnClick(deal, source)}
      >
        {text}
      </NavButton>
    );
  };

  render() {
    const { servicedDeal, publicDeal, sreoDeal } = this.props;

    return (
      <NavButtonWrapper>
        {this.renderButton(
          servicedDeal,
          DATA_SOURCE_FACADE.SERVICED,
          "Serviced"
        )}
        {this.renderButton(publicDeal, DATA_SOURCE_FACADE.PUBLIC, "Public")}
        {this.renderButton(sreoDeal, DATA_SOURCE_FACADE.SREO, "SREO")}
      </NavButtonWrapper>
    );
  }
}

export default compose(
  withRouter,
  connect(({ newDeal }) => ({
    groupedDeals: newDeal.groupedDeals,
    deal: newDeal.deal,
    servicedDeal: mapServicedDealSelector(newDeal),
    publicDeal: mapPublicDealSelector(newDeal),
    sreoDeal: mapSreoDealSelector(newDeal),
  }))
)(DealNavbar);
